import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { URL_ACCOUNT_INFO } from './RouterConfig';
import { URL_BOARD_CLASS, URL_BOARD_CLASS_DETAIL, URL_BOARD_TASK, URL_CUSTOMER_CENTER_FAQ, URL_CUSTOMER_CENTER_PRODUCT_FAQ, URL_CUSTOMER_CENTER_INQUIRY, URL_CUSTOMER_CENTER_INQUIRY_DETAIL, URL_CUSTOMER_CENTER_INQUIRY_ADD, URL_CUSTOMER_CENTER_INQUIRY_EDIT, URL_TASK_FORM_MAIN, URL_TASK_FORM_DETAIL, URL_BOARD_TASK_DETAIL } from './CommonRoute';
import {  URL_SPTP_INQUIRY, URL_SPTP_INQUIRY_ADD, URL_SPTP_INQUIRY_DETAIL, URL_SPTP_INQUIRY_EDIT, URL_SPTP_MANAGE } from './SptpRoute';

// 교육원
export const URL_SCHOOL = '/school';

// 계정정보
const AccountInfo = React.lazy(() => import('pages/school/SchoolAccountInfo'))

// 회원관리
const MemberManage = React.lazy(() => import('pages/school/member/manage/MemberManageMain'));
const MemberManageEdit = React.lazy(() => import('pages/school/member/manage/MemberManageEdit'));
const MemberStudy = React.lazy(() => import('pages/school/member/study/MemberStudy'));
const MemberStudyDetail = React.lazy(() => import('pages/school/member/study/MemberStudyDetail'));
const MemberJoinCounsel = React.lazy(() => import('pages/school/member/join-counsel/MemberJoinCounselMain'));
const MemberTeacher = React.lazy(() => import('pages/school/member/teacher/MemberTeacher'));
const MemberTeacherDetail = React.lazy(() => import('pages/school/member/teacher/MemberTeacherDetail'));
const MemberTeacherAdd = React.lazy(() => import('pages/school/member/teacher/MemberTeacherAdd'));
const MemberTeacherEdit = React.lazy(() => import('pages/school/member/teacher/MemberTeacherEdit'));

export const URL_SCHOOL_MEMBER = '/member'; //회원
export const URL_SCHOOL_MEMBER_MANAGE = `${URL_SCHOOL_MEMBER}/manage`; // 회원관리
export const URL_SCHOOL_MEMBER_MANAGE_EDIT = `${URL_SCHOOL_MEMBER_MANAGE}/edit/:no`; // 회원수정
export const URL_SCHOOL_MEMBER_STUDY = `${URL_SCHOOL_MEMBER}/study`; // 학습관리
export const URL_SCHOOL_MEMBER_STUDY_DETAIL = `${URL_SCHOOL_MEMBER_STUDY}/:no`; // 학습상세
export const URL_SCHOOL_MEMBER_JOIN_COUNSEL = `${URL_SCHOOL_MEMBER}/join-counsel`; // 입회상담 관리
export const URL_SCHOOL_MEMBER_TEACHER = `${URL_SCHOOL_MEMBER}/teacher`; // 강사관리
export const URL_SCHOOL_MEMBER_TEACHER_DETAIL = `${URL_SCHOOL_MEMBER_TEACHER}/:no`; // 강사상세
export const URL_SCHOOL_MEMBER_TEACHER_ADD = `${URL_SCHOOL_MEMBER_TEACHER}/add`; // 강사등록
export const URL_SCHOOL_MEMBER_TEACHER_EDIT = `${URL_SCHOOL_MEMBER_TEACHER}/edit/:no`; // 강사수정

// 주문관리
const OrderBook = React.lazy(() => import('pages/school/order/book/OrderBook'));
const OrderBookStep = React.lazy(() => import('pages/school/order/book/OrderBookMain'));
const OrderProduct = React.lazy(() => import('pages/school/order/product/OrderProduct'));
const OrderProductDetail = React.lazy(() => import('pages/school/order/product/OrderProductDetail'));
const OrderProductPay = React.lazy(() => import('pages/school/order/product/OrderProductPay'));
const OrderProductCart = React.lazy(() => import('pages/school/order/product-cart/OrderProductCart'));
const OrderHistory = React.lazy(() => import('pages/school/order/history/OrderHistory'));
const OrderHistoryDetail = React.lazy(() => import('pages/school/order/history/OrderHistoryDetail'));
const OrderHistoryRefund = React.lazy(() => import('pages/school/order/history/OrderHistoryRefund'));
const OrderUpdate = React.lazy(() => import('pages/school/order/update/OrderUpdate'));
const OrderProductRefund = React.lazy(() => import('pages/school/order/product-refund/OrderProductRefund'));
const OrderProductRefundDetail = React.lazy(() => import('pages/school/order/product-refund/OrderProductRefundDetail'));
const OrderRecovery = React.lazy(() => import('pages/school/order/recovery/OrderRecovery'));
const OrderMember = React.lazy(() => import('pages/school/order/member/OrderMemberMain'));
const OrderPoint = React.lazy(() => import('pages/school/order/point/OrderPoint'));
const OnlyPay = React.lazy(() => import('pages/school/order/OnlyPay'));

export const URL_SCHOOL_ORDER = '/order'; // 주문
export const URL_SCHOOL_ORDER_BOOK = `${URL_SCHOOL_ORDER}/book`; // 교재주문 신규,기존 주문 선택
export const URL_SCHOOL_ORDER_BOOK_STEP = `${URL_SCHOOL_ORDER_BOOK}/step`; // 교재주문 step
export const URL_SCHOOL_ORDER_PRODUCT = `${URL_SCHOOL_ORDER}/product`; // 물품주문
export const URL_SCHOOL_ORDER_PRODUCT_DETAIL = `${URL_SCHOOL_ORDER_PRODUCT}/:no`; // 물품상세
export const URL_SCHOOL_ORDER_PRODUCT_PAY = `${URL_SCHOOL_ORDER_PRODUCT}/pay`; // 물품결제
export const URL_SCHOOL_ORDER_PRODUCT_CART = `${URL_SCHOOL_ORDER}/product-cart`; // 물품 장바구니
export const URL_SCHOOL_ORDER_HISTORY = `${URL_SCHOOL_ORDER}/history`; // 주문내역/요청
export const URL_SCHOOL_ORDER_HISTORY_DETAIL = `${URL_SCHOOL_ORDER_HISTORY}/:no`; // 주문내역/요청 상세
export const URL_SCHOOL_ORDER_HISTORY_REFUND = `${URL_SCHOOL_ORDER_HISTORY}/refund/:no`; // 주문내역/요청 환불
export const URL_SCHOOL_ORDER_UPDATE = `${URL_SCHOOL_ORDER}/update`; // 교재 주문수정/교환내역
export const URL_SCHOOL_ORDER_PRODUCT_REFUND = `${URL_SCHOOL_ORDER}/product-refund`; // 물품 환불관리
export const URL_SCHOOL_ORDER_PRODUCT_REFUND_DETAIL = `${URL_SCHOOL_ORDER_PRODUCT_REFUND}/:no`; // 물품 환불관리
export const URL_SCHOOL_ORDER_RECOVERY = `${URL_SCHOOL_ORDER}/recovery`; // 회수내역
export const URL_SCHOOL_ORDER_MEMBER = `${URL_SCHOOL_ORDER}/member`; // 회원별 교재 내역
export const URL_SCHOOL_ORDER_POINT = `${URL_SCHOOL_ORDER}/point`; // 적립금 내역
export const URL_SCHOOL_ORDER_ONLY_PAY = `${URL_SCHOOL_ORDER}/pay`; // 결제

// SPTP
const SptpManage = React.lazy(() => import('pages/school/sptp/manage/SptpManageMain'));
const SptpInquiry = React.lazy(() => import('pages/school/sptp/inquiry/SptpInquiry'));
const SptpInquiryDetail = React.lazy(() => import('pages/school/sptp/inquiry/SptpInquiryDetail'));
const SptpInquiryAdd = React.lazy(() => import('pages/school/sptp/inquiry/SptpInquiryAdd'));
const SptpInquiryEdit = React.lazy(() => import('pages/school/sptp/inquiry/SptpInquiryAdd'));

// 마감보고서 관리
const CloseManage = React.lazy(() => import('pages/school/close/CloseManage'));
const CloseManageDetail = React.lazy(() => import('pages/school/close/CloseManageDetail'));
const CloseManageAdd = React.lazy(() => import('pages/school/close/CloseManageAdd'));

export const URL_SCHOOL_CLOSE = '/close'; // 마감보고서
export const URL_SCHOOL_CLOSE_MANAGE = `${URL_SCHOOL_CLOSE}/manage`; // 마감보고서 관리
export const URL_SCHOOL_CLOSE_MANAGE_DETAIL = `${URL_SCHOOL_CLOSE_MANAGE}/:no`; // 마감보고서 상세
export const URL_SCHOOL_CLOSE_MANAGE_ADD = `${URL_SCHOOL_CLOSE_MANAGE}/add`; // 마감보고서 등록

// 게시판
const BoardTask = React.lazy(() => import('pages/school/board/task/BoardTaskMain'));
const BoardTaskDetail = React.lazy(() => import('pages/school/board/task/BoardTaskDetail'));
const BoardClass = React.lazy(() => import('pages/school/board/class/BoardClassMain'));
const BoardClassDetail = React.lazy(() => import('pages/school/board/class/BoardClassDetail'));

// 업무서식
const TaskFormMain = React.lazy(() => import('pages/school/task-form/TaskFormMain'));
const TaskFormDetail = React.lazy(() => import('pages/school/task-form/TaskFormDetail'));

//고객센터
const CustomerCenterInquiry = React.lazy(() => import('pages/school/customer-center/inquiry/CustomerCenterInquiryMain'));
const CustomerCenterInquiryDetail = React.lazy(() => import('pages/school/customer-center/inquiry/CustomerCenterInquiryDetail'));
const CustomerCenterInquiryAdd = React.lazy(() => import('pages/school/customer-center/inquiry/CustomerCenterInquiryAdd'));
const CustomerCenterInquiryEdit = React.lazy(() => import('pages/school/customer-center/inquiry/CustomerCenterInquiryEdit'));
const CustomerCenterFaq = React.lazy(() => import('pages/school/customer-center/faq/CustomerCenterFaqMain'));
const CustomerCenterProductFaq = React.lazy(() => import('pages/school/customer-center/product-faq/CustomerCenterProductFaqMain'));

/**
 * 교육원
 * @returns
 */
const SchoolRoute = ({ common }) => {
  return (
    <Routes>
      {/* 계정정보 */}
      <Route path={URL_ACCOUNT_INFO} element={<AccountInfo common={common} />} />

      {/* 회원관리 */}
      <Route path={URL_SCHOOL_MEMBER_MANAGE} element={<MemberManage common={common} />} />
      <Route path={URL_SCHOOL_MEMBER_MANAGE_EDIT} element={<MemberManageEdit common={common} />} />
      <Route path={URL_SCHOOL_MEMBER_STUDY} element={<MemberStudy common={common} />} />
      <Route path={URL_SCHOOL_MEMBER_STUDY_DETAIL} element={<MemberStudyDetail common={common} />} />
      <Route path={URL_SCHOOL_MEMBER_JOIN_COUNSEL} element={<MemberJoinCounsel common={common} />} />
      <Route path={URL_SCHOOL_MEMBER_TEACHER} element={<MemberTeacher common={common} />} />
      <Route path={URL_SCHOOL_MEMBER_TEACHER_DETAIL} element={<MemberTeacherDetail common={common} />} />
      <Route path={URL_SCHOOL_MEMBER_TEACHER_ADD} element={<MemberTeacherAdd common={common} />} />
      <Route path={URL_SCHOOL_MEMBER_TEACHER_EDIT} element={<MemberTeacherEdit common={common} />} />

      {/* 주문관리 */}
      <Route path={URL_SCHOOL_ORDER_BOOK} element={<OrderBook common={common} />} />
      <Route path={URL_SCHOOL_ORDER_BOOK_STEP} element={<OrderBookStep common={common} />} />
      <Route path={URL_SCHOOL_ORDER_PRODUCT} element={<OrderProduct common={common} />} />
      <Route path={URL_SCHOOL_ORDER_PRODUCT_DETAIL} element={<OrderProductDetail common={common} />} />
      <Route path={URL_SCHOOL_ORDER_PRODUCT_PAY} element={<OrderProductPay common={common} />} />
      <Route path={URL_SCHOOL_ORDER_PRODUCT_CART} element={<OrderProductCart common={common} />} />
      <Route path={URL_SCHOOL_ORDER_HISTORY} element={<OrderHistory common={common} />} />
      <Route path={URL_SCHOOL_ORDER_HISTORY_DETAIL} element={<OrderHistoryDetail common={common} />} />
      <Route path={URL_SCHOOL_ORDER_HISTORY_REFUND} element={<OrderHistoryRefund common={common} />} />
      <Route path={URL_SCHOOL_ORDER_UPDATE} element={<OrderUpdate common={common} />} />
      <Route path={URL_SCHOOL_ORDER_PRODUCT_REFUND} element={<OrderProductRefund common={common} />} />
      <Route path={URL_SCHOOL_ORDER_PRODUCT_REFUND_DETAIL} element={<OrderProductRefundDetail common={common} />} />
      <Route path={URL_SCHOOL_ORDER_RECOVERY} element={<OrderRecovery common={common} />} />
      <Route path={URL_SCHOOL_ORDER_MEMBER} element={<OrderMember common={common} />} />
      <Route path={URL_SCHOOL_ORDER_POINT} element={<OrderPoint common={common} />} />
      <Route path={URL_SCHOOL_ORDER_ONLY_PAY} element={<OnlyPay common={common} />} />

      {/* SPTP */}
      <Route path={URL_SPTP_MANAGE} element={<SptpManage common={common} />} />
      <Route path={URL_SPTP_INQUIRY} element={<SptpInquiry common={common} />} />
      <Route path={URL_SPTP_INQUIRY_DETAIL} element={<SptpInquiryDetail common={common} />} />
      <Route path={URL_SPTP_INQUIRY_ADD} element={<SptpInquiryAdd common={common} />} />
      <Route path={URL_SPTP_INQUIRY_EDIT} element={<SptpInquiryEdit common={common} />} />

      {/* 마감보고서 관리 */}
      <Route path={URL_SCHOOL_CLOSE_MANAGE} element={<CloseManage common={common} />} />
      <Route path={URL_SCHOOL_CLOSE_MANAGE_DETAIL} element={<CloseManageDetail common={common} />} />
      <Route path={URL_SCHOOL_CLOSE_MANAGE_ADD} element={<CloseManageAdd common={common} />} />

      {/* 게시판 */}
      <Route path={URL_BOARD_TASK} element={<BoardTask common={common} />} />
      <Route path={URL_BOARD_TASK_DETAIL} element={<BoardTaskDetail common={common} />} />
      <Route path={URL_BOARD_CLASS} element={<BoardClass common={common} />} />
      <Route path={URL_BOARD_CLASS_DETAIL} element={<BoardClassDetail common={common} />} />

      {/* 업무서식 */}
      <Route path={URL_TASK_FORM_MAIN} element={<TaskFormMain common={common} />} />
      <Route path={URL_TASK_FORM_DETAIL} element={<TaskFormDetail common={common} />} />

      {/* 고객센터 */}
      <Route path={URL_CUSTOMER_CENTER_INQUIRY} element={<CustomerCenterInquiry common={common} />} />
      <Route path={URL_CUSTOMER_CENTER_INQUIRY_DETAIL} element={<CustomerCenterInquiryDetail common={common} />} />
      <Route path={URL_CUSTOMER_CENTER_INQUIRY_ADD} element={<CustomerCenterInquiryAdd common={common} />} />
      <Route path={URL_CUSTOMER_CENTER_INQUIRY_EDIT} element={<CustomerCenterInquiryEdit common={common} />} />
      <Route path={URL_CUSTOMER_CENTER_FAQ} element={<CustomerCenterFaq common={common} />} />
      <Route path={URL_CUSTOMER_CENTER_PRODUCT_FAQ} element={<CustomerCenterProductFaq common={common} />} />
    </Routes>
  );
};

export default SchoolRoute;
